/*
Copyright NetFoundry, Inc.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/


/**
 * Default options.
 */

const defaultOptions = {
  
  /**
   * See {@link Options.zitiContext}
   *
   */
   zitiContext: null,

    /**
     * See {@link Options.session_token}
     *
     */
    session_token: null,

    /**
     * See {@link Options.network_session_token}
     *
     */
    network_session_token: null,

    /**
     * See {@link Options.data}
     *
     */
    data: null,

    /**
     * See {@link Options.edgeRouter}
     *
     */
    edgeRouter: null,

    /**
     * See {@link Options.timeout}
     */
    timeout: 0,

    /**
     * See {@link Options.helloTimeout}
     */
    helloTimeout: 0,

};

export {
  defaultOptions
}
